import { useState } from 'react'

const useCustomerPendingsContext = () => {
  const [customerPendingsContext, setCustomerPendingsContext] = useState({
    vouchers: [],
    debts: [],
    orders: [],
  })

  return { customerPendingsContext, setCustomerPendingsContext }
}

export default useCustomerPendingsContext
